import { PaymentOrderStatusMap } from '../../data/enumerators/paymentOrderStatus';

const getPaymentOrderStatus = (status) => (PaymentOrderStatusMap.get(+status).description);

export default getPaymentOrderStatus;
